module.exports = {"id":"dp5_1l1q5","text":"Software installation","instructions":"Keeping software updated helps devices function correctly.","multiselect":false,"category":"5.1","questionType":"PickOne","random":false,"options":[{"id":"dp5_1l1q5-a1","text":"True","score":1.8},{"id":"dp5_1l1q5-a2","text":"Not sure","score":0},{"id":"dp5_1l1q5-a3","text":"False","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l1q5.json
// module id = 1285
// module chunks = 41